// Gallary Js Start
document.addEventListener("DOMContentLoaded", function () {

  function getSelectedOptions() {
    let opts = [];

    document.querySelectorAll('input[data-option-position]:checked').forEach(el => {
      let label = el.nextElementSibling?.querySelector('.sr-only, span')?.innerText || "";
      opts.push(label.trim().toLowerCase());
    });

    return opts;
  }
  
  function updateGallery() {
    
    let selected = getSelectedOptions();
    let selectedString = selected.join('|');

    document.querySelectorAll('.product-gallery__media').forEach(media => {
      let img = media.querySelector('[alt]');
      if (!img) return;

      let alt = img.getAttribute('alt').trim().toLowerCase();

      // ALWAYS SHOW DEFAULT
      if (alt === "default") {
        media.hidden = false;
        return;
      }

      // ALWAYS SHOW common
      if (alt === "common") {
        media.hidden = false;
        return;
      }

      // FULL MATCH (Black|Pack of 1)
      if (alt === selectedString) {
        media.hidden = false;
        return;
      }

      // PARTIAL MATCH (Black OR Pack of 1)
      let altParts = alt.split('|').map(a => a.trim());

      let matches = altParts.every(p => selected.includes(p));

      media.hidden = !matches;
    });

    // Update thumbnails too
    document.querySelectorAll('.product-gallery__thumbnail').forEach(thumb => {
      let id = thumb.getAttribute('data-media-id');
      let target = document.querySelector('.product-gallery__media[data-media-id="' + id + '"]');
      thumb.hidden = target?.hidden;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateGallery();

    // ⭐ FIX: FORCE carousel to start at the first slide after reload
    setTimeout(() => {
      try {
        const carouselElem =
          document.querySelector('.product-gallery__carousel') ||
          document.querySelector('.product-gallery');

        if (window.Flickity && carouselElem) {
          const flkty = window.Flickity.data(carouselElem);
          if (flkty) {
            flkty.select(0, false, true); // (index, isWrapped, isInstant)
          }
        }

        const carouselComponent = document.querySelector('carousel-component');
        if (carouselComponent) {
          carouselComponent.select && carouselComponent.select(0);
        }
      } catch (e) {}
    }, 250);
  });

  // Run once
  updateGallery();

  // Run on variant change
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[data-option-position]')) {
      updateGallery();
    }
  });

});

function getSelectedOptions() {
  const values = [];

  // 1) standard select inputs (name starts with "options")
  document.querySelectorAll('[name^="options"]').forEach(el => {
    if (el.tagName === 'SELECT') values.push(el.value.trim().toLowerCase());
    else if (el.type === 'radio' && el.checked) values.push(el.value.trim().toLowerCase());
    else if ((el.type === 'text' || el.tagName === 'INPUT') && el.value) values.push(el.value.trim().toLowerCase());
  });

  // 2) variant pickers that use data-option-index attributes (swatches)
  // find inputs/buttons with data-option-index and data-option-value
  document.querySelectorAll('[data-option-index]').forEach(el => {
    const idx = el.getAttribute('data-option-index');
    const val = el.getAttribute('data-option-value') || el.dataset.value || el.value;
    if (!val) return;
    // if it's part of a radio-like group, prefer the checked/active one
    if (el.checked || el.classList.contains('active') || el.getAttribute('aria-pressed') === 'true') {
      values.push(String(val).trim().toLowerCase());
    }
  });

  // 3) fallback: look for .single-option-selector (some themes)
  document.querySelectorAll('.single-option-selector').forEach(el => {
    if (el.value) values.push(el.value.trim().toLowerCase());
  });

  // Remove empty and dedupe while preserving order
  const out = [];
  values.forEach(v => { if (v && out.indexOf(v) === -1) out.push(v); });
  dbg('selected options', out);
  return out;
}
/* ===== Prestige gallery: robust dot + active-sync + click handler =====
   Drop this in once (replace previous gallery-filter JS). */
(function () {
  // Small helper
  function q(sel, el=document) { return el.querySelector(sel); }
  function qa(sel, el=document) { return Array.from(el.querySelectorAll(sel)); }

  // Reads selected options in a robust way (Prestige structure)
  function getSelectedOptionsForFilter() {
    const values = [];

    // radio swatches with data-option-position
    qa('input[data-option-position]:checked').forEach(i => {
      // try to read human label text (sr-only or sibling span)
      const label = i.parentElement?.querySelector('.sr-only, span')?.innerText || i.value || '';
      if (label) values.push(label.trim().toLowerCase());
    });

    // fallback for select inputs or classic option selectors
    qa('[name^="options"], .single-option-selector').forEach(el => {
      if (el.tagName === 'SELECT' && el.value) values.push(el.value.trim().toLowerCase());
      else if (el.matches('.single-option-selector') && el.value) values.push(el.value.trim().toLowerCase());
    });

    // dedupe
    return values.filter((v, i, a) => v && a.indexOf(v) === i);
  }

  // Build / update dots and wire interactions & active state
  function rebuildDotsAndWire(visibleMedia) {
    const nav = q('carousel-navigation') || q('.page-dots') || q('.product-gallery__pagination') || null;
    if (!nav) return;

    // clear
    nav.innerHTML = '';

    // create dot for each visible media
    visibleMedia.forEach((mediaEl, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tap-area';
      btn.innerHTML = `<span class="sr-only">Go to item ${idx + 1}</span>`;
      btn.dataset.index = idx;

      // click: scroll corresponding visible slide into view (works with any carousel)
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        // scroll media into view smoothly
        mediaEl.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'center'});
        setActiveDot(idx, nav);
      });

      nav.appendChild(btn);
    });

    // hide nav if nothing visible
    nav.style.display = visibleMedia.length ? '' : 'none';

    // return nav element for possible use
    return nav;
  }

  // Set aria-current on dots
  function setActiveDot(index, navEl) {
    const buttons = qa('button.tap-area', navEl || document);
    buttons.forEach((b, i) => {
      if (i === index) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }

  // Find visible slides after filtering (not display:none, visible)
  function findVisibleMedia() {
    const carouselElem = document.querySelector('.product-gallery__carousel');
    const f = window.Flickity && carouselElem ? Flickity.data(carouselElem) : null;

    if (f && f.slides && f.slides.length) {
      return f.slides
        .map(s => s.cells[0]?.element)
        .filter(el => el && !el.hidden);
    }

    // fallback DOM order
    return qa('.product-gallery__media').filter(m => !m.hidden);
  }

  // Keep dot active in sync with which visible slide is mostly in view
  let io = null;
  function observeVisibleSlidesSync(navEl, visibleMedia) {
    // clean previous observer
    if (io) io.disconnect();

    if (!visibleMedia.length) return;

    // map element -> index in visibleMedia
    const indexMap = new Map(visibleMedia.map((el, i) => [el, i]));

    io = new IntersectionObserver((entries) => {
      // pick the entry with largest intersectionRatio
      let best = null;
      entries.forEach(en => {
        if (!best || en.intersectionRatio > best.intersectionRatio) best = en;
      });
      if (best && indexMap.has(best.target)) {
        setActiveDot(indexMap.get(best.target), navEl);
      }
    }, { root: q('.product-gallery__carousel') || q('.product-gallery__carousel.scroll-area') || null, threshold: [0.4, 0.6, 0.9] });

    visibleMedia.forEach(el => io.observe(el));
  }

  // Attempt to call theme carousel refresh safely
   // Attempt to call theme carousel refresh safely
  function safeRefreshCarousel() {
    try {
      const carouselElem = q('.product-gallery__carousel') || q('.product-gallery') || q('[id^="product-gallery-carousel-"]') || null;

      if (window.Flickity && carouselElem) {
        const f = Flickity.data(carouselElem);
        if (f) {
          // preserve current index if possible
          const currentIndex = typeof f.selectedIndex === 'number' ? f.selectedIndex : (f.selected ? f.selected.index : 0);

          // reload cells and resize
          f.reloadCells && f.reloadCells();
          f.resize && f.resize();

          // if the preserved index is still valid, select it; otherwise clamp to 0
          const newMax = (f.slides && f.slides.length) ? f.slides.length - 1 : 0;
          const toSelect = Math.min(Math.max(0, currentIndex || 0), newMax);
          // IMPORTANT: do not force an instant jump unless necessary
          if (typeof f.select === 'function') f.select(toSelect, false, true);
          return;
        }
      }

      const carouselComponent = q('carousel-component');
      if (carouselComponent) {
        // preserve index if available
        const currentIndex = Number.isFinite(+carouselComponent.index) ? +carouselComponent.index : 0;
        carouselComponent.refresh && carouselComponent.refresh();

        // clamp to available slides if possible, then re-select
        if (typeof carouselComponent.select === 'function') {
          carouselComponent.select(currentIndex);
        }
        return;
      }

    } catch (e) {
      console.warn('Gallery: safeRefreshCarousel failed', e);
    }
  }

  // MAIN: call after you updated display state of .product-gallery__media
  function syncDotsToFilteredGallery() {

    // find visible (post-filter) media (array of elements)
    const visibleMedia = findVisibleMedia();

    // Build a stable identifier list for visible media so we can compare to previous state
    const visibleIds = visibleMedia.map((el) => {
      return el.getAttribute('data-media-id') || el.dataset.mediaId || el.id || (el.querySelector && el.querySelector('img')?.src) || '';
    });

    // If visible list hasn't changed since last run, skip heavy refresh/select actions.
    // This prevents jumping back to slide 0 when user simply scrolls between already-visible slides.
    const prev = window.__p_visible_media_ids || [];
    if (prev.length === visibleIds.length && prev.every((v,i) => v === visibleIds[i])) {
      // still update dots active state (in case intersection changed)
      const navEl = rebuildDotsAndWire(visibleMedia);
      setActiveDot(0, navEl); // default to 0 if needed; observeVisibleSlidesSync will set actual active soon
      if (navEl) observeVisibleSlidesSync(navEl, visibleMedia);
      // no refresh / no re-select
      return;
    }

    // Persist new visible ids
    window.__p_visible_media_ids = visibleIds;

    // rebuild dots & wire clicks
    const navEl = rebuildDotsAndWire(visibleMedia);

    // ensure carousel refresh if possible but preserve user position
    safeRefreshCarousel();

    // ensure the first visible media is scrolled into view BUT only if we actually changed the visible set
   // instead of unconditional scrollIntoView:
   // Disable gallery auto-scroll ONLY on the sales page for FIRST load
let allowAutoScroll = true;

if (window.location.pathname === "/pages/sales-page") {
  allowAutoScroll = false;

  // Re-enable auto-scroll after ANY user interaction
  const enableScroll = () => {
    allowAutoScroll = true;
    document.removeEventListener("click", enableScroll);
    document.removeEventListener("touchstart", enableScroll);
    document.removeEventListener("change", enableScroll);
  };

  document.addEventListener("click", enableScroll, { passive: true });
  document.addEventListener("touchstart", enableScroll, { passive: true });
  document.addEventListener("change", enableScroll, { passive: true });
}

// Now the gallery scroll logic
if (visibleMedia[0] && allowAutoScroll) {
  visibleMedia[0].scrollIntoView({
    behavior: "auto" ,
    block: "nearest",
    inline: "center",
  });
}



    // set active dot safely (will be corrected by intersection observer)
    setActiveDot(0, navEl);

    // observe visible slides to update active dot when scrolled
    if (navEl) observeVisibleSlidesSync(navEl, visibleMedia);

    // set first active by default (intersection observer will quickly update if needed)
    if (navEl) setActiveDot(0, navEl);
  }


  /***** Overridable: Your existing updateGallery() should call this at its end *****
         Instead of trying to manipulate dots there, simply call syncDotsToFilteredGallery()
         after you've set display on slides.                                                 *****/

  // Convenience: observe changes to gallery and auto-run to help debugging
  // (this will auto-run if your updateGallery modified DOM)
  const galleryWrap = document.querySelector('.product-gallery__image-list') || document.querySelector('.product-gallery');
  if (galleryWrap) {
    const mo = new MutationObserver(() => {
      // slightly debounce
      clearTimeout(window.__p_gallery_sync);
      window.__p_gallery_sync = setTimeout(syncDotsToFilteredGallery, 60);
    });
    mo.observe(galleryWrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
  }

  // Provide global hook if you want to manually trigger after your update logic
  window.syncPrestigeGalleryDots = syncDotsToFilteredGallery;

  // Run once now (safeguard)
  setTimeout(syncDotsToFilteredGallery, 120);

})();
document.addEventListener("variantGalleryFix", () => {
  document.querySelectorAll('.product-gallery__media:not([hidden]) img').forEach(img => {
    if (!img.complete) {
      img.src = img.src; // force reload
    }
  });
});

// Gallary Js End

      document.addEventListener("DOMContentLoaded", function () {

        // Select ONLY the first option fieldset (Color swatches)
        const firstFieldset = document.querySelector('.variant-picker fieldset:nth-of-type(1)');

        if (firstFieldset) {

          // Uncheck all radios inside only the first fieldset
          firstFieldset.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.checked = false;
          });

          // Remove selected classes only from first fieldset swatch labels
          firstFieldset.querySelectorAll('.color-swatch').forEach(label => {
            label.classList.remove('is-selected', 'selected', 'active');
          });
        }

      });
      document.addEventListener("DOMContentLoaded", function () {

      // Loop through every product card on the page
      document.querySelectorAll('product-card').forEach(card => {

        // Find the swatch fieldset inside the card
        const fieldset = card.querySelector('fieldset');

        if (fieldset) {
          
          // Uncheck all radio buttons
          fieldset.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.checked = false;
          });

          // Remove selected/active classes from labels
          fieldset.querySelectorAll('.color-swatch').forEach(label => {
            label.classList.remove('is-selected', 'selected', 'active');
          });
        }

      });

    });

      document.addEventListener("DOMContentLoaded", function () {
      $(document).on("click", ".buy-buttons.buy-buttons, .button.aod_buy_button", function (e) {

        let colorText = $('.variant-picker__option-info legend:contains("Color")')
          .next("span")
          .text()
          .trim();

        if (colorText === '*Select Color') {

          e.preventDefault();
          e.stopPropagation();

          $('.select_message').remove();

          $(".variant-picker").before(
            "<div class='select_message' style='color:#b5838d;margin:10px 0;display:block;'>Select a shade variant</div>"
          );

          $('html, body').animate({
            scrollTop: $(".variant-picker").offset().top - 200
          }, 700);

        }
      });
    });
    // BUY BUTTON CLICK IN PRODUCT CARD
    $(document).on("click", ".product-card .aod_buy_button", function (e) {

      let card = $(this).closest(".product-card");
      let selected = card.find('input[type="radio"][data-option-position="1"]:checked');

      console.log("Buy button clicked");
      console.log("Swatch selected? →", selected.length);

      // Block checkout if no swatch
      if (selected.length === 0) {
        e.preventDefault();
        e.stopPropagation();

        console.log("No swatch selected → blocking");

        // Remove old message
        card.find(".select_message").remove();

        // Add message
        card.find("fieldset, .variants, .product-card__swatches").first().before(`
          <div class='select_message' 
            style='color:#b5838d;margin:10px 0;display:block;'>
            Please select a shade first
          </div>
        `);

        return false;
      }

      console.log("Swatch selected → allow checkout");
    });

    // REMOVE message on swatch change
    $(document).on("change", ".product-card input[type='radio'][data-option-position='1']", function () {
      let card = $(this).closest(".product-card");
      card.find(".select_message").remove();
    });



      document.addEventListener("DOMContentLoaded", function () {
        const colorLabelSpan = document.querySelector('.variant-picker__option-info legend + span');
        const colorRadios = document.querySelectorAll('.variant-picker input[type="radio"][data-option-position="1"]');

        if (colorLabelSpan) {
          colorLabelSpan.textContent = "*Select Color";
        }

        colorRadios.forEach(radio => radio.checked = false);

        document.querySelectorAll('.color-swatch').forEach(label => {
          label.classList.remove("is-selected", "active", "selected");
        });

        colorRadios.forEach(radio => {
          radio.addEventListener("change", function () {
            const selectedLabel = document.querySelector(`label[for="${this.id}"] span`).textContent.trim();

            if (colorLabelSpan) {
              colorLabelSpan.textContent = selectedLabel;
            }
          });
        });
      });
    document.addEventListener("DOMContentLoaded", function () {
        const carousel = document.querySelector("scroll-carousel.product-gallery__carousel");

        if (!carousel) return;
        customElements.whenDefined('scroll-carousel').then(() => {
          const items = Array.from(carousel.querySelectorAll('.product-gallery__media'));

          if (items.length > 1) {
            items.reverse().forEach(item => carousel.appendChild(item));
          }
        });
      });  

// Update variant id on swatch change
document.addEventListener('change', function (e) {
  const swatch = e.target.closest('fieldset input[type="radio"]');
  if (!swatch) return;

  // find its product card
  const card = swatch.closest('.product-card');
  if (!card) return;

  // get the variant id directly from swatch
  const variantId = swatch.dataset.variantId;
  if (!variantId) return;

  // find the add-to-cart form hidden variant input
  const input = card.querySelector('input[name="id"]');
  if (input) {
    input.value = variantId;
  }
});

